import React from "react";
import InfoBox from '../components/info.js'
import ImageBas from './../../images/(072)OPA-918-98.jpg'
import Panoramic from "../components/panoramic.js";

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={ImageBas} alt="" />
            <InfoBox>Aux abords du chantier naval du Port de Québec, la cité ouvrière construite pour loger les travailleurs. Photographe inconnu.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-flaneur.js